import Vue from 'vue'
import {mapGetters} from 'vuex'

Vue.mixin({
    computed: {
        ...mapGetters({
            'mixinUserInfo': 'userInfoGetter',
            'buttonsGetter': 'buttonsGetter',
            'permissionsGetter': 'permissionsGetter'
        })
    },
    data() {
        return {
            organizations: [],
            organizationChannel:[],
            workTypeList: []
        }
    },
    methods: {
        /**
         * 按钮级权限
         * @param path 当前页面路由 + '_' + 按钮关键字（添加_add，编辑_edit，删除_remove，查看_view）
         * 查看权限由菜单权限控制
         * @returns {boolean}
         */
        btnPreFn(path, say = true) {
            // 新增模块临时放行（后端配置权限后可移除）
            const newModulePrefixes = [
                'channelList', 'channelAudit', 'channelCommission', 
                'channelWithdrawal', 'channelOrder', 'channelFinancial', 'channelDetail',
                'channel_', // 渠道管理通用前缀
                'orderAnalysis', 'vehicleAnalysis', 'driverAnalysis', 
                'lineAnalysis', 'revenueAnalysis', 'passengerAnalysis' // 数据分析模块
            ];
            const isNewModule = newModulePrefixes.some(prefix => path.startsWith(prefix));
            if (isNewModule) {
                return true;
            }
            
            if (!this.buttonsGetter) return
            if (this.buttonsGetter && this.buttonsGetter[path]) {
                return true
            } else {
                if (say) {
                    this.$message.warning('你的账号无权限操作')
                }
                return false
            }
        },
        /**
         * 菜单权限
         * @param path 当前页面路由 + '_' + 按钮关键字（添加_add，编辑_edit，删除_remove，查看_view）
         * 查看权限由菜单权限控制
         * @returns {boolean}
         */
        menuPreFn(id) {
            let str = this.permissionsGetter;
            if (str) {
                let permissions = str ? str.split(',').map(value => Number(value)) : []; // 获取权限序列

                if (!permissions.includes(id)) {
                    return false
                } else {
                    return true
                }
            }
        },
        /* 接口调用-获取角色列表 */
        async mixinGetAdmins(row) {
            let url = '/api/v1/manage/admin'
            let data = await this.$axios.get(url, {page: 1, size: 999, ...row})
            if (data && data.code == 1) {
                return data.data;
            }
        },
        /* 接口调用-获取角色列表 */
        async mixinGetLines(row) {
            let url = '/api/v1/manage/line/station/scheduling/query'
            let data = await this.$axios.get(url, {page: 1, size: 999, ...row})
            if (data && data.code == 1) {
                return data.data;
            }
        },
        /**
         * 根据登录用户查询机构名称列表
         */
        async mixinOrganizations() {
            let url = '/api/v1/manage/organization/queryByAdminId';
            let data = await this.$axios.get(url);
            if (data && data.code === 1) {
                this.organizations = data.data
            }
        },
        /**
         * 根据登录用户选择归属渠道下拉数据
         */
        async mixinOrganizationChannel(params) {
            let url = '/api/v1/manage/organizationChannel/list';
            let data = await this.$axios.get(url,{...params});
            if (data && data.code === 1) {
                this.organizationChannel = data.data || []
                return data.data
            }
        },
        /**
         * 获取七牛云token
         */
        async getQiniuTokenFn() {
            let url = '/api/v1/common/qny/token';
            let data = await this.$axios.get(url);
            if (data && data.code === 1) {
                return data.data
            }
        },
        /**
         * 回显七牛云图片
         * @param item
         * @param w
         * @param h
         * @return {string}
         */
        mixinQiniuImg(item, w, h) {
            if(!item) return ''
            if (w && h && item) {
                return `${window.configure.qiniuUrl + item}?imageView2/1/w/${w}/h/${h}/format/jpg/q/75%7Cimageslim`
            } else {
                return `${window.configure.qiniuUrl + item}`
            }
        },
        numberInput(val, min = 0, max = 9999) {
            let temp = val.toString();
            temp = temp.replace(/。/g, ".");
            temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
            temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
            temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
            temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            temp = temp.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
            if(temp  < 0 || temp > 10) {
                temp = Math.min(max, Math.max(min, parseFloat(val)));
            }
            return temp;
        },

        async mixinGetWorkType() {
            let url = '/api/v1/manage/hitchRide/work/category';
            let {code, data} = await this.$axios.get(url);
            if(code == 1) {
                this.workTypeList = data;
            }
        },
        async getOrgName(orgId) {
            let url = `/api/v1/manage/organization/detail/${orgId}`
            let {code, data} = await this.$axios.get(url)
            if(code == 1) {
                return data.name
            }
        },
        /**
         * 获取车牌样式
         * @param {string} plateNumber - 车辆号牌
         * @returns {object} 样式对象
         */
        getPlateStyle(plateNumber) {
            const baseStyle = {
                display: 'inline-block',
                width: '100px',
                height: '25px',
                padding: '2px 4px',
                fontSize: '14px',
                borderRadius: '3px',
                fontWeight: '500',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                lineHeight: '25px',
            }
            const isNewEnergy = plateNumber && (
                plateNumber.length === 8 || 
                /[DF]/.test(plateNumber.substring(2, 3)) ||
                /[DF]$/.test(plateNumber)
            )
            if (isNewEnergy) {
                return {
                    ...baseStyle,
                    border: '1px solid #13c2c2',
                    background: 'linear-gradient(90deg, #e6fffb 0%, #b5f5ec 20%, #87e8de 50%, #5cdbd3 80%, #36cfc9 100%)',
                    color: '#006d75'
                }
            } else {
                return {
                    ...baseStyle,
                    border: '1px solid #0050b3',
                    background: 'linear-gradient(180deg, #1890ff 0%, #096dd9 100%)',
                    color: '#fff'
                }
            }
        },
        /**
         * 格式化车辆号牌显示
         * @param {string} plateNumber - 车辆号牌
         * @returns {string} 格式化后的车辆号牌
         */
        formatPlateNumber(plateNumber) {
            if (!plateNumber || plateNumber.length < 2) return plateNumber || '-'
            return plateNumber.slice(0, 2) + '·' + plateNumber.slice(2)
        },
        /**
         * 获取场站列表
         * @param {string} appKey - 应用密钥
         * @returns {Promise} 返回场站列表
         */
        async mixinGetStationList(appKey) {
            if (!appKey) {
                console.warn('appKey 不存在，无法加载场站列表')
                return []
            }
            try {
                const res = await this.$axios.get('/api/v1/channel/station/list', { appKey })
                if (res && res.code === 1 && res.data) {
                    const stationList = Array.isArray(res.data) ? res.data : []
                    return stationList.map(station => ({
                        label: station.stationName || '',
                        value: station.stationName || ''
                    }))
                }
                return []
            } catch (error) {
                console.error('获取场站列表失败:', error)
                this.$message.error('获取场站列表失败')
                return []
            }
        }
    }
})
